import { contextApp } from 'context';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const RoutesApp = () => {
 const { configDispatch } = contextApp();

 useEffect(() => {
  configDispatch({ type: 'REFRESH' });
 }, []);

 return <Outlet />;
};

export default RoutesApp;
